import { gql } from '@apollo/client';

import { exerciseFragment } from 'modules/exercises/graphql/fragments';

export const fillInTheBlanksExerciseFragment = gql`
  fragment FillInTheBlanksExercise on Exercise {
    ...Exercise
    questions {
      id: _id
      _id
      text
      options {
        id: _id
        _id
        type
        text
      }
    }
  }
  ${exerciseFragment}
`;
